import { ArsTableBody, ArsTableGroupCalculationDto } from "../interface";

/**
 * Recursively collects all grouping factor IDs present in an ArsTable group tree.
 *
 * @param groups - The array of table groups to inspect
 * @param ids - Set to accumulate IDs into
 */
const collectGroupingFactorIds = <T>(
  groups: ArsTableGroupCalculationDto<T>[],
  ids: Set<string>,
): void => {
  for (const group of groups) {
    if ("groupingFactor" in group) {
      ids.add(group.groupingFactor.id);
    }
    if ("subGroups" in group && group.subGroups) {
      collectGroupingFactorIds(group.subGroups, ids);
    }
  }
};

/**
 * Returns the set of all grouping factor IDs currently used in the table's
 * column and row group trees.
 *
 * @param bodyData - Current ArsTable body data
 * @returns Set of used grouping factor IDs
 */
export const computeUsedGroupingFactorIds = <T>(bodyData: ArsTableBody<T>): Set<string> => {
  const ids = new Set<string>();
  collectGroupingFactorIds(bodyData.columns, ids);
  collectGroupingFactorIds(bodyData.rows, ids);
  return ids;
};
